import ReferenceMobileScan from '@/components/ReferenceMobile/ReferenceMobileScan'
import ReferenceMobileScanDebug from '@/components/ReferenceMobile/ReferenceMobileScanDebug'
import ReferenceMobileDetail from '@/components/ReferenceMobile/ReferenceMobileDetail'

let ReferenceMobileRouter = [{
  path: '/reference_mobile/scan',
  name: 'ReferenceMobileScan',
  component: ReferenceMobileScan,
  meta: {
    title: 'Scanner une référence',
    requiresAuth: true,
    authorizations: ['reference_show', 'mobile_access']
  }
}, {
  path: '/reference_mobile/scan/debug',
  name: 'ReferenceMobileScanDebug',
  component: ReferenceMobileScanDebug,
  meta: {
    requiresAuth: true,
    authorizations: ['reference_show', 'mobile_access']
  }
}, {
  path: '/reference_mobile/:id',
  name: 'ReferenceMobileDetail',
  component: ReferenceMobileDetail,
  meta: {
    title: 'Fiche référence',
    requiresAuth: true,
    authorizations: ['reference_show', 'mobile_access']
  }
}]

export default ReferenceMobileRouter



// WEBPACK FOOTER //
// ./src/components/ReferenceMobile/router.js